import { ColumnDescription } from "react-bootstrap-table-next";
import Table from "../../../../../Components/Table";
import OrSpinner from "../../../../../Components/Utils/OrSpinner";
import { ListarParcelasExtratoClienteCompleto } from "../../../../../Controllers/Cobranca/ParcelasAbertas/ParcelasAbertasController";
import useAsyncEffect from "../../../../../hooks/useAsyncEffect";
import { formatMoneyReais } from "../../../../../Tools/FormatTools";
import moment from "moment";
import { IParcelaDadosFinanceiroGenerico } from "../../../../../Interfaces/Cobranca/ParcelasAbertas/ParcelasAbertas";

interface ITabelaDeExtratoProps {
    ID_EMPRESA: number;
    DS_OBRA: string;
    NR_VENDA: number;
}

export default function TabelaDeExtrato(props: ITabelaDeExtratoProps) {
    const { value: lstExtratoParcelas, loading } = useAsyncEffect(async () => {
        const ID_CHAVE_ERP = `${props.ID_EMPRESA}_${props.DS_OBRA}_${props.NR_VENDA}`;
        return ListarParcelasExtratoClienteCompleto(
            {
                DT_CALCULO: new Date().toISOString(),
                ID_CHAVE_ERP,
            },
            false
        );
    }, []);

    return (
        <OrSpinner loading={loading} spinner="erp">
            <Table
                data={lstExtratoParcelas ?? []}
                columns={columns}
                keyField="NR_PARCELA"
                noDataIndication={
                    <div className="text-center text-muted">
                        Nenhuma parcela
                    </div>
                }
                loading={loading}
                wrapperClasses="wrapperTable mw-100 x-scroll"
                noSearch
                classes="tableClasses"
                bordered={false}
                center
                defaultStyle={{
                    align: "center",
                    classes: "p-2",
                }}
            />
        </OrSpinner>
    );
}

const footerFormatter = (dataArray: Array<number | undefined>) =>
    formatMoneyReais(
        dataArray.reduce((sum: number, data) => sum + (data ?? 0), 0)
    );

const columns: Array<ColumnDescription<IParcelaDadosFinanceiroGenerico>> = [
    {
        dataField: "NR_PARCELA",
        text: "Parcela",
        footerAlign: "center",
        footer: "",
    },
    {
        dataField: "DS_PARCELA",
        text: "Tipo",
        footerAlign: "center",
        footer: "",
    },
    {
        dataField: "DT_BASE",
        text: "Dt. Base",
        formatter: (c) => moment(c).format("DD/MM/yy"),
        footerAlign: "center",
        footer: "",
    },
    {
        dataField: "VL_ORIGINAL",
        text: "Valor Original",
        formatter: formatMoneyReais,
        footerAlign: "center",
        footer: footerFormatter,
    },
    {
        dataField: "DT_VENCIMENTO",
        text: "Dt. Vencimento",
        formatter: (c) => moment(c).format("DD/MM/yy"),
        footerAlign: "center",
        footer: "",
    },
    {
        dataField: "VL_SALDO_ATUAL",
        text: "Saldo atual",
        formatter: formatMoneyReais,
        footerAlign: "center",
        footer: footerFormatter,
    },
    {
        dataField: "NR_DIAS",
        text: "Dias",
        formatter: (c) => c ?? 0,
        footerAlign: "center",
        footer: "",
    },
    {
        dataField: "DT_PAGAMENTO",
        text: "Dt. Baixa",
        formatter: (c) => (c ? moment(c).format("DD/MM/yy") : ""),
        footerAlign: "center",
        footer: "",
    },
    {
        dataField: "VL_PAGAMENTO",
        text: "Valor baixa",
        formatter: (c, row) => (row.FL_PAGO ? formatMoneyReais(c) : ""),
        footerAlign: "center",
        footer: footerFormatter,
    },
    {
        dataField: "VL_ACRESIMO",
        text: "Acréscimo",
        formatter: (c, row) => (row.FL_PAGO ? formatMoneyReais(c) : ""),
        footerAlign: "center",
        footer: footerFormatter,
    },
    {
        dataField: "VL_DESCONTO",
        text: "Desconto",
        formatter: (c, row) => (row.FL_PAGO ? formatMoneyReais(c) : ""),
        footerAlign: "center",
        footer: footerFormatter,
    },
    {
        dataField: "VL_LIQUIDO",
        text: "Líquido",
        formatter: (c, row) => (row.FL_PAGO ? formatMoneyReais(c) : ""),
        footerAlign: "center",
        footer: footerFormatter,
    },
];
